<template>
  <div>      

    <section class="event-section">
        <div class="container">
            <div class="row">
                <div class="col-md-12 text-center">
                    <h2 class="sec-title"><span>test paper center</span> 试卷中心</h2>
                </div>
            </div>
            <div class="row" v-if="exams&&exams.length>0&&$root.buytype!=2">
                <div class="col-md-6" v-for="(exam,index) in exams" :key="index">
                    <div class="event-item-1">
                        <div class="e-date">{{exam.totalscore}} <span>试卷总分</span></div>
                        <h4><span>{{exam.title}}</span></h4>
                        <p class="">考试科目：{{exam.examinee.join(",")}}</p>
                        <p class="">试卷类型：{{exam.papertype=='test'?'模拟考试':'竞聘考试'}}</p>
                        <!-- <p class="">试卷总分：{{exam.totalscore}}分</p> -->
                        <p class="">及格分数：{{exam.passingscore}}分</p>
                        <p class="">考试时长：{{exam.duration}}分钟</p>
                        <p class="">考试模式：{{getExamTimes(exam.frepeat)}}</p>
                        <p class="">到期时间：{{exam.endtime}}</p>
                        <!-- <p class="" :style="exam.examState!=='end'?'color:#51be78':`color:gray`">考试状态：<span >{{getExamState1(exam.examState)}}</span></p> -->
                        <a  @click="enterExam(exam)" class="bisylms-btn" v-if="!(exam.examState=='end')">{{getExamState(exam.examState)}}</a>
                    </div>
                </div>
            </div>
            <el-card  v-else  class="box-card">
                <el-empty description="暂无相关考试"></el-empty>
            </el-card>
            <div class="row">
                <div class="col-md-12 text-center">
                    <router-link  to="/papercenter" class="read-more">所有考试<i class="arrow_right"></i></router-link>
                </div>
            </div>
        </div>
    </section>
    <el-dialog
        :visible.sync="faceVisible"
        :width="faceWidth"
        title="请保持脸部在取景框内"
        :show-close="false"
        center
        >
        <face-live-ex v-if="faceVisible" :visibleFlag="faceVisible" :examId ="selExams._id" ref="faceBox" @chgWidth="chgWidth($event)" @VerfiyPass="verfiyPass($event)" @VerfiyFailed = "faceVisible= false"/>
        <span slot="footer" class="dialog-footer">
            <el-button @click="faceVisible = false;" >取 消</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
import FaceLive from "../PublicComs/FaceLive.vue";
import FaceLiveEx from "../PublicComs/FaceLiveEx.vue";
import { Message} from "element-ui";
export default {
  components: { FaceLive, FaceLiveEx },
  data() {
    return {
      exams: [],
      faceVisible: false,
      global,
      faceWidth: "500px",
      selExams: {},
      
    };
  },
  //
  mounted() {
    if (this.global.isPhone()) {
      this.faceWidth = "90%";
    }
    this.$axios
      .get(`/api/students/testPapers?page=1&limit=6&sort=-createdAt`)
      .then((res) => {
        if (res.data) {
          this.exams = res.data.data;
        }
      });
  },
  methods: {
    enterExam(exam) {
      if(exam.examState=='noStart')
      {
        Message.error(`请在 ${exam.examstarttime}之后进行考试!`);
        return;
      }else if(exam.examState=='usertimeend')
      {
        Message.error(`考试已结束!`);
        return;
      }
      if(exam.endtime)
      {
        if(exam.endtime<this.dateFormat(new Date(),'yyyy-MM-dd'))
        {
          Message.error("学习时间已到期！");
          return;
        }
      }
      if (exam.checkface&&this.$root.ischeckface) {
        this.faceVisible = true;
        this.selExams = exam;
      } else {
        this.selExams = exam;
        this.verfiyPass();
      }
    },
    verfiyPass() {
      this.$router.push(
        this.global.isPhone()
          ? `/exam/${this.selExams._id}`
          : `/exampc/${this.selExams._id}`
      );
    },
    chgWidth(faceWidth) {
      this.faceWidth = faceWidth;
    },
    dateFormat(date, format) {
      var o = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour 24
        "H+": date.getHours(), //hour 24
        "m+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        S: date.getMilliseconds(), //millisecond
      };

      if (/(y+)/.test(format)) {
        format = format.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }

      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return format;
    },
    NewDate(str) {
      if (!str) {
        return 0;
      }
      let arr = str.split(" ");
      let d = arr[0].split("-");
      let t = arr[1].split(":");
      var date = new Date();
      date.setUTCFullYear(d[0], d[1] - 1, d[2]);
      date.setUTCHours(t[0], t[1], t[2], 0);
      return date;
    },
    getExamTimes(times) {
      switch (times) {
        case "0":
          return "不可补考";
        case "1":
          return "可补考一次";
        case "2":
          return "不限次数";
      }
    },
    getExamState(state) {
      switch (state) {
        case "newStart":
          return "开始考试";
        case "resit":
          return "开始补考";
        case "repeatStart":
          return "重新考试";
        case "continue":
          return "继续考试";
        case "end":
          return "考试结束";
        case "noStart":
          return "未开始";
        case "usertimeend":
          return "考试结束";
        default:
          return "开始考试";
      }
    },
    getExamState1(state) {
      switch (state) {
        case "newStart":
          return "正在考试";
        case "resit":
          return "正在考试";
        case "repeatStart":
          return "正在考试";
        case "continue":
          return "正在考试";
        case "end":
          return "考试完成";
        default:
          return "正在考试";
      }
    },
  },
};
</script>
<style scoped>
</style>
